import Flex from "common/Boxes/Flex";
import Text from "common/Typography/Text";
import { ORDER_TYPE_TO_TRAILING_TITLE } from "@shared/features/tradingTerminal/common/constants";
import React from "react";
import { LanguageNameSpaces, OrderTypes } from "@shared/types";
import { TrailingSummaryRowProps } from "@shared/features/tradingTerminal/common/types";
import useTrailingSummaryRow from "@shared/features/tradingTerminal/common/hooks/useTrailingSummaryRow";
import { OverrideType } from "@shared/features/bots/BotForm/common/types.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

const TrailingSummaryRow = ({ orderType }: TrailingSummaryRowProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);
  const { trailing, useTrailing, trailingStopDisplayData, isSignal } =
    useTrailingSummaryRow();

  const getTrailingDisplay = (orderType: OrderTypes) => {
    if (!useTrailing[orderType]) {
      return isSignal ? OverrideType.USER_CONFIGURATION : t("labels.without");
    }
    if (orderType === OrderTypes.STOP) {
      return (
        <Flex $flexDirection={"column"} $alignItems={"flex-end"}>
          <Text>
            {trailingStopDisplayData.type}
            {trailingStopDisplayData.value}
          </Text>
          <Text>
            {trailingStopDisplayData.triggerType}:{" "}
            {trailingStopDisplayData.triggerValue}
          </Text>
        </Flex>
      );
    } else {
      return `${trailing[orderType]}%`;
    }
  };

  return (
    <Flex $alignItems="flex-start">
      <Text type="secondary">{t(ORDER_TYPE_TO_TRAILING_TITLE[orderType])}</Text>
      <Text as="div">{getTrailingDisplay(orderType)}</Text>
    </Flex>
  );
};

export default TrailingSummaryRow;
